<script lang="ts">
  import { icons } from '../config';
  import type { IconNames, Variants } from '../types';

  export let name: IconNames;
  export let variant: keyof Variants = 'default';

  export let width: number | undefined = undefined;
  export let height: number | undefined = undefined;
  export let fill: string | undefined = 'none';
  export let focusable: 'false' | 'true' = 'false';
  export let classes: string | undefined = '';

  $: displayIcon = icons[name];
  $: svg = displayIcon.variants[variant] || displayIcon.variants.default;
</script>

<svg
  class="{classes}"
  width="{width ?? displayIcon.sizes.w}px"
  height="{height ?? displayIcon.sizes.h}px"
  {fill}
  {focusable}
  viewBox="0 0 {displayIcon.sizes.w} {displayIcon.sizes.h}"
>
  <!-- eslint-disable-next-line -->
  {@html svg}
</svg>
